import type { Provider } from '@app/src/types/organizations'
import paths from '@app/src/wf-constants/paths'
import { Box, Divider } from '@mui/material'
import React from 'react'
import { useRouteMatch } from 'react-router-dom'

import Permissions, { usePermissions } from '@app/src/auth/permissions'
import { useFlags } from 'launchdarkly-react-client-sdk'
import BaselineAssessmentOverview from './BaselineAssessmentOverview'
import ProductOverview from './ProductOverview'
import RequestsOverview from './RequestsOverview'
import RiskStatusOverview from './RiskStatusOverview'

type CompanyOverviewProps = {
  provider: Provider
}

const CompanyOverview: React.FC<CompanyOverviewProps> = ({ provider }) => {
  const { path } = useRouteMatch()
  const { productMapping } = useFlags()
  const { hasPermission } = usePermissions()

  const isResourcePage = path === paths.resourceExplorer

  if (isResourcePage) {
    return null
  }

  return (
    <Box>
      {hasPermission(Permissions.ASSESSMENT_TEMPLATE_ACCESS) && <BaselineAssessmentOverview providerId={provider.id} />}
      <RequestsOverview providerId={provider.id} />
      {productMapping && <ProductOverview providerId={provider.id} />}
      <Divider sx={{ m: 2 }} />
      <RiskStatusOverview provider={provider} />
    </Box>
  )
}

export default CompanyOverview
